<template>
  <button
    v-if="icon"
    class="baseGridIcon mds-button mds-button--icon-only"
    @click="$emit('click', $event)"
    @mouseover="$emit('showToolTip', $event, formattedValue)"
    @mouseleave="$emit('hideToolTip')"
  >
    <svg
      class="tg-cell-hover-icon treegrid-caret mds-icon mds-button__icon"
      :class="`mds-icon__${icon}`"
      aria-hidden="true"
    >
      <use xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:xlink:href="iconPath"></use>
    </svg>
  </button>
</template>
<script>
export default {
  name: 'baseGridIcon',
  props: ['icon', 'tooltipMessage'],
  computed: {
    formattedValue() {
      if (Array.isArray(this.tooltipMessage)) {
        return this.tooltipMessage;
      }
      return [this.tooltipMessage];
    },
    iconPath() {
      return `static/mds/icons/mds.svg#${this.icon}`;
    },
  },
};
</script>
